import styled from "styled-components";


export const FullHeightDiv = styled.div`
 height: 100%;
`
